<app-shared-stock-search
  (stockItemsSelected)="handleSelectedItems($event)"
  [gridColDefs]="gridColDefs"
  [gridOptions]="gridOptions"
  [limitItems]="false"
  [setStockData]="(stockSearchData$ | async)"
  [title]="'Add Stock Items to Quote'"
  [useStockSearchStore]="true"
  [stockSearchStore]="currentStore">
</app-shared-stock-search>
